import { GET} from "../../helper/collaticaRestFunctions";

export const getOrgUserDetails = async (org_id: any, org_user_id: any) => {
  const path = `/orgs/${org_id}/users/${org_user_id}`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching users > ", err);
      return err;
    });
};
